var React = require('react');

function InlineSvg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.0002 0.46875C10.8861 0.46875 7.04844 4.35381 3.65248 10.0158C0.256523 15.6779 -1.14002 21.024 1.06139 24.4382C3.26275 27.8524 8.54062 29.5312 14.9998 29.5312L15.0002 29.5312C21.4594 29.5312 26.7373 27.8524 28.9386 24.4382C31.14 21.024 29.7435 15.6779 26.3475 10.0158C22.9517 4.35403 19.1144 0.46875 15.0002 0.46875Z","fill":"#7A55FF"}));
}

InlineSvg.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = InlineSvg;

InlineSvg.default = InlineSvg;
